import { render, staticRenderFns } from "./SidebarCard.vue?vue&type=template&id=3468bd18&scoped=true"
import script from "./SidebarCard.vue?vue&type=script&lang=js"
export * from "./SidebarCard.vue?vue&type=script&lang=js"
import style0 from "./SidebarCard.vue?vue&type=style&index=0&id=3468bd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468bd18",
  null
  
)

export default component.exports